// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-main[data-v-3750fcba]{background-image:url(http://file.sl.dande.online/static/landing/template/bgMain.png);background-attachment:fixed;background-position:50%;background-size:cover}", ""]);
// Exports
module.exports = exports;
